import React, { useEffect, useState } from "react";
import { Modal, Typography, Table, Space } from "antd";
import dayjs from "dayjs";
import styles from "./ReviewModal.module.css";

const ReviewModal = ({
  open,
  setOpen,
  reviewList,
  onShowClick,
  onEditClick,
  isActive,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const isWithin24Hours = (dateString) => {
    const hoursDiff = dayjs().diff(dayjs(dateString), "hour");
    return hoursDiff < 24;
  };

  const columns = [
    {
      title: "Created By",
      dataIndex: "created_by_first_name",
      key: "created_by_first_name",
      ellipsis: true,
      render: (value, record) => `${value} ${record?.created_by_last_name}`,
    },
    {
      title: "Date",
      dataIndex: "created_at",
      key: "created_at",
      width: isMobile ? 110 : undefined,
      render: (value) => dayjs(value)?.format("DD, MMM hh:mm A"),
    },
    {
      title: "",
      key: "actions",
      width: isMobile ? 72 : 100,
      render: (_, record) => (
        <Space size={8}>
          <Typography.Link onClick={() => onShowClick(record)}>
            Show
          </Typography.Link>
          {isWithin24Hours(record.created_at) && isActive && (
            <Typography.Link onClick={() => onEditClick(record)}>
              Edit
            </Typography.Link>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      footer={null}
      title="Review History"
      width={isMobile ? "min(92vw, 360px)" : 520}
      centered={isMobile}
      className={styles.reviewHistoryModal}
      destroyOnClose
    >
      <Table
        columns={columns}
        dataSource={reviewList}
        pagination={false}
        rowKey="id"
        size="small"
        scroll={isMobile ? { x: 420 } : undefined}
      />
    </Modal>
  );
};

export default ReviewModal;
